export const USER_REQUEST = 'USER_REQUEST';
export const USER_REQUEST_SUCCESS = 'USER_REQUEST_SUCCESS';
export const USER_REQUEST_FAILURE = 'USER_REQUEST_FAILURE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_SUBMISSION_ACCESS = 'USER_SUBMISSION_ACCESS';
export const USER_FORM_ACCESS = 'USER_FORM_ACCESS';
export const USER_PROJECT_ACCESS = 'USER_PROJECT_ACCESS';
export const USER_ROLES = 'USER_ROLES';
